module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "maintenanceNotice",
    staticClass: "maintenance-notice-modal",
    on: {
      "open": _vm.opened,
      "close": _vm.closed
    }
  }, [_c('md-dialog-title', [_c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Notice")])]), _vm._v(" "), _c('md-dialog-content', {
    staticClass: "maintenance-notice-modal-content"
  }, [_c('div', {
    staticClass: "maintenance-message"
  }, [_c('p', [_vm._v("Due to an urgent, mandatory maintenance requirement our site is currently unable to process new payments. We are working hard on the issue and expect a resolution within "), _c('b', [_vm._v("48 hours")]), _vm._v(". If you need immediate attention due to this, please reach out to "), _c('a', {
    attrs: {
      "href": "mailto:info@thecuelist.com"
    }
  }, [_vm._v("info@thecuelist.com")]), _vm._v(" for help. Thank you for your patience!")])])]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("OK")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd08d0c2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/maintenance-notice.vue
// module id = 1288
// module chunks = 21